export { default } from './TemplatePdfView';
